import React, { useEffect, useState } from 'react';
import { Tracking } from '@iwoca/frontend-tracking-library';
import { Button, Icon } from '@iwoca/orion';
import { Trans } from '@lingui/macro';
import { useIntroducerContext } from 'contexts/IntroducerContext/IntroducerContext';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import styles from '../InviteModal.module.css';

interface Props {
  text: string;
}

export const InviteButton: React.FunctionComponent<Props> = (props: Props) => {
  const [hideCopied, setHideCopied] = useState(true);
  const { introducerCompany } = useIntroducerContext();

  const copyLink = () => {
    setHideCopied(false);
    Tracking.trackEvent({ event: 'Copied invite link' });
  };

  useEffect(() => {
    const hideCopiedTimeout = setTimeout(() => setHideCopied(true), 2000);
    return () => {
      clearTimeout(hideCopiedTimeout);
    };
  }, [hideCopied]);

  if (introducerCompany?.shared_applications) {
    return null;
  }

  return (
    <CopyToClipboard text={props.text} onCopy={() => copyLink()}>
      <Button variant="primary" size="small" className={styles.button}>
        {hideCopied ? (
          <>
            <Trans>Copy invite link</Trans>
            <Icon icon="link" className={styles.icon} />
          </>
        ) : (
          <Trans>The link was copied to your clipboard</Trans>
        )}
      </Button>
    </CopyToClipboard>
  );
};
